import { SpecificationEmbodimentImprovementModel } from './models/specification-embodiment-improvement-model';
import { SpecificationEmbodimentImprovementModelImpl } from './models/impls/specification-embodiment-improvement-model';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';

export const embodimentImprovementModule = (bind: interfaces.Bind) => {
    bind(SpecificationEmbodimentImprovementModel).to(SpecificationEmbodimentImprovementModelImpl);
};
